import React, { useEffect, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { InputText } from 'primereact/inputtext'
import classes from "./ServiceRequestDetails.module.scss";
import ProjectDetailsService from '../../../../../../services/ProjectDetailsService';

interface ServiceRequestDetailsProps {
    selectedServiceRequestDetails: any
    selectedServiceRequestNumber: any
    isServiceRequestNumber?: boolean;
    errors: any[]
    setIsDisableContinue: React.Dispatch<React.SetStateAction<boolean>>;
    setIsFetchingProject: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedServiceRequestDetails: React.Dispatch<React.SetStateAction<any>>;
    setSelectedServiceRequestNumber: React.Dispatch<React.SetStateAction<any>>;
    onSuggestionServiceRequestSelect: () => void;
    checkField: (value: any, fieldName: string) => void;
    clearState: () => void
}

const ServiceRequestDetails = ({
    selectedServiceRequestDetails,
    selectedServiceRequestNumber,
    errors,
    setSelectedServiceRequestNumber,
    onSuggestionServiceRequestSelect,
    checkField,
    clearState
}: ServiceRequestDetailsProps) => {
    const [serviceRequestProjects, setServiceRequestProjects] = useState<any[]>([])

    const getProjectSuggestions = async (event: any) => {
        const value = event.query.trim()
        const projectNumbers = await ProjectDetailsService.getProjectSuggestionsByServiceRequestNumber(value)
        setServiceRequestProjects(projectNumbers)

    }

    return (
        <>
            <div className="field-row">
                <label htmlFor="serviceRequestNumber" className="w-15">
                    <span className="add-error">*</span>Service Request Number
                </label>
                <div className="w-35 plr-10">
                    <AutoComplete
                        id="serviceRequestNumber"
                        inputId="service_Request_Number"
                        field="service_Request_Number"
                        value={selectedServiceRequestNumber}
                        suggestions={serviceRequestProjects}
                        completeMethod={getProjectSuggestions}
                        onChange={e => setSelectedServiceRequestNumber(e.value)}
                        onSelect={onSuggestionServiceRequestSelect}
                        className="ul-input-style"
                        placeholder="Type at least 3 characters"
                        onBlur={() => checkField(selectedServiceRequestNumber, 'project')}
                        minLength={3}
                        onClear={clearState}
                    />
                    {errors.includes('project') && (
                        <span className="add-error add-helper">Service Request Number is required</span>
                    )}
                </div>
                <label htmlFor="customerCompanyName" className="w-15">
                    Customer Company Name
                </label>
                <div className="w-35 plr-10">
                    <input
                        type="text"
                        id="customerCompanyName"
                        className="ul-textbox"
                        value={selectedServiceRequestDetails?.companyName || ''}
                        disabled
                    />
                </div>
            </div>
            <div className="field-row">
                <label htmlFor="projectName" className="w-15">
                    Project Name
                </label>
                <div className="w-85 plr-10">
                    <input
                        type="text"
                        id="projectName"
                        className="ul-textbox"
                        value={selectedServiceRequestDetails?.name || ''}
                        disabled
                    />
                </div>
            </div>
        </>

    )
}

export default ServiceRequestDetails